{
  "natural": {
    "label": "Natural",
    "roleLabel": "Natural role",
    "filterAll": "Natural role: all",
    "ariaLabel": "Natural role: {primary} / {secondary}",
    "ariaLabelSingle": "Natural role: {primary}"
  },
  "bestRole": {
    "label": "Best role now",
    "filterAll": "Best role now: all",
    "title": "{role} is the role he rates highest in right now. The number is his rating as {role}."
  },
  "types": {
    "sprinter": "Sprinter",
    "tt": "Time-trialist",
    "climber": "Climber",
    "puncheur": "Puncheur",
    "brostensrytter": "Cobbles specialist",
    "baroudeur": "Baroudeur",
    "rouleur": "Rouleur",
    "gc": "GC contender"
  },
  "short": {
    "sprinter": "Sprint",
    "tt": "ITT",
    "climber": "Climb",
    "puncheur": "Punch",
    "brostensrytter": "Cobbles",
    "baroudeur": "Break",
    "rouleur": "Rouleur",
    "gc": "GC"
  }
}
